import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import "./Subheader.css";

function Subheader({ title, updatedAt }) {
  return (
    <Container>
      <Row className="pb-2 pt-2">
        <Col lg={6}>
          <span className="header-page">{title}</span>
        </Col>
        {updatedAt && (
          <Col lg={6} className="d-flex justify-content-end">
            <span className="header-page">{"Última atualização: " + new Date(updatedAt).toLocaleString("pt-BR")}</span>
          </Col>
        )}
      </Row>
    </Container>
  );
}

export default Subheader;
